<template>
  <Skeleton v-bind="props" />
</template>

<script setup lang="ts">
  import Skeleton, { SkeletonProps } from "primevue/skeleton";

  type Props = Omit<SkeletonProps, "">;

  const props = withDefaults(defineProps<Props>(), {});
</script>
